import socket from "../../../sockets/socket";

const ChatService = {

    register(email, type) {
        socket.emit("register", { email, type });
    },

    pair(adminId, userId) {
        socket.emit("pair", userId);
    },

    sendMessage(message) {
        socket.emit("message", message);
    },

    typing({ adminEmail, userEmail, type }) {
        socket.emit("typing", {
            adminEmail,
            userEmail,
            type
        });
    },

    stopTyping({ adminEmail, userEmail, type }) {
        socket.emit("stopTyping", {
            adminEmail,
            userEmail,
            type
        });
    },

    sendMessageSeen(data) {
        socket.emit("messageSeen", data);
    },


    listenMessageSeen(callback) {
        socket.on("messageSeen", callback);
    },

    removelistenMessageSeen() {
        socket.off("messageSeen");
    },

    listen(event, callback) {
        socket.on(event, callback);
    },

    remove(event) {
        socket.off(event);
    }
};

export default ChatService;
